import React from 'react'
import { ISidebarMenu, IMenuItem } from './types'
import { Space } from '../../layouts'
import { StyledNavLink } from '../StyledNavLink'
import { Caption, P2 } from '../StyledText'
import { StyledMenuText } from './styled'

export const SidebarMenu = ({ caption, menu }: ISidebarMenu) => (
  <>
    <Space pl={6} pr={6}>
      <Caption variant="caption">{caption}</Caption>
    </Space>
    <section>
      {menu.map(({ title, href, description }: IMenuItem) => (
        <StyledNavLink
          key={title + href}
          to={href}
          isActive={(_, { pathname }) => {
            const linkPath = href.replace(/\?.*/, '')
            return (
              pathname.toLowerCase() === linkPath ||
              pathname.startsWith(`${linkPath}/`)
            )
          }}
        >
          <StyledMenuText>{title}</StyledMenuText>
          {description && <P2>{description}</P2>}
        </StyledNavLink>
      ))}
    </section>
  </>
)
